<script>
import Layout from '@layouts/primary'
import { vehicleMethods, serviceTypeMethods, depotMethods } from '@state/helpers'
import * as SERVICES from '@state/service-checklist';

export default {
  $_veeValidate: {
    validator: 'new',
  },
  page: {
    title: 'View Truck Service',
    meta: [{ name: 'description', content: 'ViewTruckService' }],
  },
  components: { Layout },
  data() {
    return {
      vehicle: {},
      attributesDesc:[],
      attributesObj: [],
      inCabList: SERVICES.inCabList,
      truckExternalList: SERVICES.truckExternalList,
      engineCompartmentList: SERVICES.engineCompartmentList,
      underVehicleList: SERVICES.underVehicleList,
      bodyList: SERVICES.bodyList,
      axlesList: SERVICES.axlesList,
      arrayAxlesObjs: [],
      vehicleLog: this.$router.history.current.params.vehicleServiceLog,
      editVehicle: false,
      removeVehicle:false,
      dictionary: {
        attributes: {
          email: 'E-mail Address',
          // custom attributes
        },
        custom: {
          name: {
            required: () => 'Name can not be empty',
            max: 'The name field may not be greater than 10 characters',
            // custom messages
          },
          select: {
            required: 'Select field is required',
          },
        },
      },
    }
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData'
  },
  created () {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData()
  },
  mounted() {
    this.$validator.localize('en', this.dictionary);
    this.fetchData();
    // this.vehicleLog = this.$router.history.current.params.vehicleServiceLog;
    // console.log(this.vehicleLog)
    // console.log(this.axlesList)

    let arrayAxlesObjs = [];

    // Build axle Obj to display correct info in the report
    if(this.axlesList && this.vehicleLog){
      for(let i in this.axlesList){
        let _id = parseInt(i);
        _id +=1 ;

        let obj = {
          id: parseInt(_id),
          leftValue: [],
          desc: "",
          rightValue: []
        };

        obj.leftValue = this.vehicleLog.axelLH[i];
        obj.rightValue = this.vehicleLog.axelRH[i];
        obj.desc = this.axlesList[i];
        arrayAxlesObjs.push(obj)
      }

      this.arrayAxlesObjs = arrayAxlesObjs;
    }
  },
  methods: {
    ...vehicleMethods, ...serviceTypeMethods, ...depotMethods,
    fetchData () {
      this.vehicleLog = this.$router.history.current.params.vehicleServiceLog;
    },
    update() {
      this.$validator.validateAll()
    },
    submit() {

    },
    clear() {
      this.$validator.reset()
      this.editVehicle = false
    },
    changeRoute(r) {
      this.$router.push(r)
    },
    defineItemChecked(num){
      // Define color according to tyres replaced
      let tyres = this.vehicleLog.tyres;
      let tyreClass = "tyre-white";
      for (let i in tyres){
        if(tyres[i] === num){
          tyreClass = "tyre";
        }
      }
      return tyreClass
    }
  }
}
</script>

<template>
  <Layout>
    <VContainer grid-list-md>
      <h2>View Truck Service</h2>
      <VCard class="v-card-padding top-blue">
        <h3
          v-if="vehicleLog"
          class="fixedSpaceVertical"
        >
          <i class="fas fa-truck fixedSpaceHorizontal" /> Vehicle Registration - {{ vehicleLog.truckRego }}
        </h3>
        <VLayout
          row
          wrap
          class="client-card"
        >
          <div
            class="serviceTitle"
          >
            <h5><strong>IN CAB</strong></h5>
          </div>
          <VFlex
            xs12
            sm12
            md12
            lg12
            class="serviceContainer"
            style="padding-top: 0 !important;"
          >
            <br>
            <div
              v-for="inCabItem in inCabList"
              :key="inCabItem"
            >
              <VLayout
                align-center
                justify-space-between
                row
                fill-height
              >

                <VFlex
                  xs10
                  sm10
                  md11
                  lg11
                  style="padding-left: 0 !important;"
                >
                  <div class="serviceDesc">
                    <p>{{ inCabItem }}</p>
                  </div>
                </VFlex>

                <VFlex
                  xs2
                  sm2
                  md1
                  lg1
                  style="padding-right: 0 !important; padding-left: 0 !important;"
                >
                  <div class="tyre-white">
                    <i class="fas fa-check" />
                  </div>
                </VFlex>

              </VLayout>
            </div>

          </VFlex>
        </VLayout>

        <VLayout
          row
          wrap
          class="client-card"
        >
          <div
            class="serviceTitle"
          >
            <h5><strong>TRUCK EXTERNAL</strong></h5>
          </div>
          <VFlex
            xs12
            sm12
            md12
            lg12
            class="serviceContainer"
            style="padding-top: 0 !important;"
          >
            <br>
            <div
              v-for="truckExtItem in truckExternalList"
              :key="truckExtItem"
            >
              <VLayout
                align-center
                justify-space-between
                row
                fill-height
              >

                <VFlex
                  xs10
                  sm10
                  md11
                  lg11
                  style="padding-left: 0 !important;"
                >
                  <div class="serviceDesc">
                    <p>{{ truckExtItem }}</p>
                  </div>
                </VFlex>

                <VFlex
                  xs2
                  sm2
                  md1
                  lg1
                  style="padding-right: 0 !important; padding-left: 0 !important;"
                >
                  <div class="tyre-white">
                    <i class="fas fa-check" />
                  </div>
                </VFlex>

              </VLayout>
            </div>

          </VFlex>
        </VLayout>

        <VLayout
          row
          wrap
          class="client-card"
        >
          <div
            class="serviceTitle"
          >
            <h5><strong>ENGINE COMPARTMENT</strong></h5>
          </div>
          <VFlex
            xs12
            sm12
            md12
            lg12
            class="serviceContainer"
            style="padding-top: 0 !important;"
          >
            <br>
            <div
              v-for="engineItem in engineCompartmentList"
              :key="engineItem"
            >
              <VLayout
                align-center
                justify-space-between
                row
                fill-height
              >

                <VFlex
                  xs10
                  sm10
                  md11
                  lg11
                  style="padding-left: 0 !important;"
                >
                  <div class="serviceDesc">
                    <p>{{ engineItem }}</p>
                  </div>
                </VFlex>

                <VFlex
                  xs2
                  sm2
                  md1
                  lg1
                  style="padding-right: 0 !important; padding-left: 0 !important;"
                >
                  <div class="tyre-white">
                    <i class="fas fa-check" />
                  </div>
                </VFlex>

              </VLayout>
            </div>

          </VFlex>
        </VLayout>

        <VLayout
          row
          wrap
          class="client-card"
        >
          <div
            class="serviceTitle"
          >
            <h5><strong>UNDER VEHICLE</strong></h5>
          </div>
          <VFlex
            xs12
            sm12
            md12
            lg12
            class="serviceContainer"
            style="padding-top: 0 !important;"
          >
            <br>
            <div
              v-for="underItem in underVehicleList"
              :key="underItem"
            >
              <VLayout
                align-center
                justify-space-between
                row
                fill-height
              >

                <VFlex
                  xs10
                  sm10
                  md11
                  lg11
                  style="padding-left: 0 !important;"
                >
                  <div class="serviceDesc">
                    <p>{{ underItem }}</p>
                  </div>
                </VFlex>

                <VFlex
                  xs2
                  sm2
                  md1
                  lg1
                  style="padding-right: 0 !important; padding-left: 0 !important;"
                >
                  <div class="tyre-white">
                    <i class="fas fa-check" />
                  </div>
                </VFlex>

              </VLayout>
            </div>

          </VFlex>
        </VLayout>

        <VLayout
          row
          wrap
          class="client-card"
        >
          <div
            class="serviceTitle"
          >
            <h5><strong>BODY</strong></h5>
          </div>
          <VFlex
            xs12
            sm12
            md12
            lg12
            class="serviceContainer"
            style="padding-top: 0 !important;"
          >
            <br>
            <div
              v-for="bodyItem in bodyList"
              :key="bodyItem"
            >
              <VLayout
                align-center
                justify-space-between
                row
                fill-height
              >

                <VFlex
                  xs10
                  sm10
                  md11
                  lg11
                  style="padding-left: 0 !important;"
                >
                  <div class="serviceDesc">
                    <p>{{ bodyItem }}</p>
                  </div>
                </VFlex>

                <VFlex
                  xs2
                  sm2
                  md1
                  lg1
                  style="padding-right: 0 !important; padding-left: 0 !important;"
                >
                  <div class="tyre-white">
                    <i class="fas fa-check" />
                  </div>
                </VFlex>

              </VLayout>
            </div>

          </VFlex>
        </VLayout>

        <br>
        <VLayout
          row
          wrap
        >

          <VFlex
            xs12
            sm6
            md6
            lg6
            class="axlesContainer"
            style="padding-top: 0 !important;"
          >

            <VLayout
              row
              align-center
              justify-space-between
              class="axlesTitle client-card"
            >
              <VFlex
                xm2
                sm2
                md2
                lg2
              >
                <h5>LH</h5>
              </VFlex>

              <VFlex
                xm8
                sm8
                md8
                lg8
              >
                <h5>TABLE A – AXLE CONFIGURATION_X_</h5>
              </VFlex>

              <VFlex
                xm2
                sm2
                md2
                lg2
              >
                <h5>RH</h5>
              </VFlex>

            </VLayout>
            <VLayout
              row
              align-center
              justify-space-between
              class="axlesTitle client-card"
            >

              <VFlex
                xm12
                sm12
                md12
                lg12
                class="axleSubtitle"
              >
                <h5>Minimum brake friction material is 8 mm Change brake pads when percentage reading reaches 15 %</h5>
              </VFlex>
            </VLayout>

            <div
              v-for="axleItem in arrayAxlesObjs"
              :key="axleItem.id"
            >
              <VLayout
                row
                align-center
                justify-space-between
                class="axleItem"
              >
                <VFlex
                  xm2
                  sm3
                  md3
                  lg2
                >
                  <div class="whiteInput">
                    {{ axleItem.leftValue }}
                  </div>
                </VFlex>

                <VFlex
                  xm8
                  sm6
                  md6
                  lg8
                >
                  <h5>{{ axleItem.desc }}</h5>
                </VFlex>

                <VFlex
                  xm2
                  sm3
                  md3
                  lg2
                >
                  <div class="whiteInput">
                    {{ axleItem.rightValue }}
                  </div>
                </VFlex>

              </VLayout>
            </div>
          </VFlex>

          <VFlex
            xs12
            sm6
            md6
            lg6
            class="flex"
          >
            <h5><strong>Extra Information</strong></h5>
            <br>
            <p v-if="vehicleLog">
              <i class="fas fa-calendar fixedSpaceHorizontal" />
              <strong class="subtitleStrong">
                Date:
              </strong>
              {{ vehicleLog.dateFormated }}
            </p>
            <p v-if="vehicleLog">
              <i class="fas fa-info-circle fixedSpaceHorizontal" />
              <strong class="subtitleStrong">
                Vehicle mileage:
              </strong>
              {{ vehicleLog.truckKm }}
            </p>
            <p v-if="vehicleLog">
              <i class="fas fa-check fixedSpaceHorizontal" />
              <strong class="subtitleStrong">
                Service Number:
              </strong>
              {{ vehicleLog.serviceNumber }}
            </p>
            <p v-if="vehicleLog">
              <i class="fas fa-user fixedSpaceHorizontal" />
              <strong class="subtitleStrong">
                Mechanic Name:
              </strong>
              {{ vehicleLog.mechanicsName }}
            </p>
            <p v-if="vehicleLog">
              <i class="fas fa-address-card fixedSpaceHorizontal" />
              <strong class="subtitleStrong">
                Mechanic License:
              </strong>
              {{ vehicleLog.mechanicsLicense }}
            </p>
            <p>
              <strong class="subtitleStrong">
                Mechanic Signature
              </strong>
            </p>
            <div
              v-if="vehicleLog"
              id="signatureFitter"
            >
              <img
                :src="vehicleLog.signature_url"
              >
            </div>
            <div
              v-if="vehicleLog"
              class="signature-notes"
            >
              <h5>Additional Comments:</h5>
              {{ vehicleLog.additionalNotes }}
            </div>
            <VFlex
              v-for="attribute in vehicle.attributes"
              :key="attribute.id"
              xs12
              style="padding: 0 !important"
            >
              <p><i class="fas fa-check fixedSpaceHorizontal" /> {{ attribute.description }} </p>
            </VFlex>
          </VFlex>
        </VLayout>
        <VSpacer />
      </VCard>
    </VContainer>
  </Layout>
</template>

<style lang="scss" module>
  @import '@design';
</style>
